import { ol_Feature } from "@omnia/exports/openlayers"
import { fields, FieldViewModel } from "../../../omnia"
import { CroppingLayer } from "@omnia/shared/fields/map/layers/croppingLayer"

export class CroppingLayerStyle extends fields.map.layers.CroppingLayerStyle {

    constructor(
        layer: CroppingLayer,
        private readonly getSelectedFieldId: () => number
    ) {

        super(layer)

    }

    protected isSelected(feature: ol_Feature, selected: boolean): boolean {

        const fieldId = this.getSelectedFieldId()

        if (!selected) {
            const vm = feature.get("data") as FieldViewModel
            selected = fieldId === vm?.fieldId
        }

        return selected

    }

    protected getFillColorOpacity(selected: boolean): number {

        const fieldId = this.getSelectedFieldId()

        if (!fieldId) {
            return super.getFillColorOpacity(selected)
        }

        return selected ? 0.75 : 0.15

    }
}
